import React from 'react'
import '../../styles/TextField.css'

const FormTextField = ({ label, name, value, onChange, type = 'text', error }) => (
  <div className='formFieldContainer'>
    <label className='formLabel'>
      {label}
      <input className='textField'
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {error && <span className="errorMessage">{error}</span>}
    </label>
    </div>
  );

  export default FormTextField;
